/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UseCheckImeiServiceRequest = {
    serviceId: string;
    imeiOrSerial: string;
    ownerId: string;
    ownerType: UseCheckImeiServiceRequest.ownerType;
};
export namespace UseCheckImeiServiceRequest {
    export enum ownerType {
        SHOP = 'SHOP',
        REVENUE = 'REVENUE',
        THIRD_PARTY = 'THIRD_PARTY',
        CLEARING = 'CLEARING',
        BANKS = 'BANKS',
        FINANCIER = 'FINANCIER',
    }
}

